var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", [
        _c("p", {
          staticClass: "icon-jujue closeBtn",
          on: { click: _vm.routerBack },
        }),
      ]),
      _c(
        "div",
        { staticClass: "content_box" },
        [
          _c(
            "el-row",
            { staticStyle: { margin: "5px 0" } },
            [
              _vm.rmcProduceAuditorId === "0" &&
              (!_vm.detailForm.auditStatus ||
                _vm.detailForm.auditStatus === "Draft")
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "acl",
                          rawName: "v-acl",
                          value: _vm.RMC_PROD_AUDITOR_SAVE,
                          expression: "RMC_PROD_AUDITOR_SAVE",
                        },
                      ],
                      staticClass: "btn",
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.onAddSave },
                    },
                    [_vm._v("保存")]
                  )
                : _vm._e(),
              _vm.isShowEditSave
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "acl",
                          rawName: "v-acl",
                          value: _vm.RMC_PROD_AUDITOR_SAVE,
                          expression: "RMC_PROD_AUDITOR_SAVE",
                        },
                      ],
                      staticClass: "btn",
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.onEditSave },
                    },
                    [_vm._v("保存")]
                  )
                : _vm._e(),
              _vm.isShowSub
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "acl",
                          rawName: "v-acl",
                          value: _vm.RMC_PROD_AUDITOR_SUBMIT,
                          expression: "RMC_PROD_AUDITOR_SUBMIT",
                        },
                      ],
                      staticClass: "btn",
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.onSubmit },
                    },
                    [_vm._v("提交")]
                  )
                : _vm._e(),
              _vm.detailForm.auditStatus === "PendingApproval" &&
              _vm.ms_roles.indexOf("QSPI_RMC_PRODUCE_CQS") !== -1
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "acl",
                          rawName: "v-acl",
                          value: _vm.RMC_PROD_AUDITOR_APPROVE,
                          expression: "RMC_PROD_AUDITOR_APPROVE",
                        },
                      ],
                      staticClass: "btn",
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.onApprove },
                    },
                    [_vm._v("批准")]
                  )
                : _vm._e(),
              _vm.detailForm.auditStatus === "PendingApproval" &&
              _vm.ms_roles.indexOf("QSPI_RMC_PRODUCE_CQS") !== -1
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "acl",
                          rawName: "v-acl",
                          value: _vm.RMC_PROD_AUDITOR_APPROVE,
                          expression: "RMC_PROD_AUDITOR_APPROVE",
                        },
                      ],
                      staticClass: "btn",
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.onReturn },
                    },
                    [_vm._v("退回")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-form",
            {
              ref: "detailForm",
              attrs: {
                model: _vm.detailForm,
                rules: _vm.rules,
                "label-width": "140px",
              },
            },
            [
              _c("div", { staticClass: "within_box" }, [
                _c("div", { staticClass: "title_box" }, [
                  _c("p", { staticClass: "line" }),
                  _c("p", { staticClass: "title" }, [_vm._v("审核员清单")]),
                ]),
                _c(
                  "div",
                  { staticClass: "form_box" },
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "Category3",
                                  prop: "category3Code",
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      disabled:
                                        _vm.isDisabled || _vm.isForbidden,
                                      clearable: "",
                                      placeholder: "请选择",
                                    },
                                    model: {
                                      value: _vm.detailForm.category3Code,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.detailForm,
                                          "category3Code",
                                          $$v
                                        )
                                      },
                                      expression: "detailForm.category3Code",
                                    },
                                  },
                                  _vm._l(
                                    _vm.category3CodeOptions,
                                    function (item, index) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: item.object,
                                          value: item.key,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "Sponsor",
                                  prop: "sponsorName",
                                },
                              },
                              [
                                _c(
                                  "el-input",
                                  {
                                    attrs: {
                                      readonly: "",
                                      placeholder: "从供应商集团选择",
                                    },
                                    model: {
                                      value: _vm.detailForm.sponsorName,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.detailForm,
                                          "sponsorName",
                                          $$v
                                        )
                                      },
                                      expression: "detailForm.sponsorName",
                                    },
                                  },
                                  [
                                    _c("el-button", {
                                      attrs: {
                                        slot: "append",
                                        icon: "el-icon-search",
                                        disabled:
                                          _vm.isSponsor || _vm.isForbidden,
                                      },
                                      on: { click: _vm.onFacility },
                                      slot: "append",
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                class:
                                  _vm.isSponsor &&
                                  !(
                                    _vm.detailForm.auditorType.length === 1 &&
                                    _vm.detailForm.auditorType[0] ===
                                      "SecondParty"
                                  )
                                    ? "is-required"
                                    : "",
                                attrs: {
                                  label: "Farm Group",
                                  prop: "farmGroupId",
                                  rules: _vm.rules.farmGroupId,
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      clearable: "",
                                      disabled: _vm.isForbidden,
                                      placeholder: "请选择",
                                    },
                                    model: {
                                      value: _vm.detailForm.farmGroupId,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.detailForm,
                                          "farmGroupId",
                                          $$v
                                        )
                                      },
                                      expression: "detailForm.farmGroupId",
                                    },
                                  },
                                  _vm._l(
                                    _vm.farmGroupOptions,
                                    function (item, index) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: item.farmGroup,
                                          value: item.rmcProduceFarmGroupId,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "is-required",
                                attrs: {
                                  label: "审核员",
                                  prop: "auditorName",
                                  rules: _vm.rules.auditorName,
                                },
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    disabled: _vm.isForbidden,
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.detailForm.auditorName,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.detailForm,
                                        "auditorName",
                                        $$v
                                      )
                                    },
                                    expression: "detailForm.auditorName",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "is-required",
                                attrs: {
                                  label: "性别",
                                  prop: "auditorGender",
                                  rules: _vm.rules.auditorGender,
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      clearable: "",
                                      disabled: _vm.isForbidden,
                                      placeholder: "请选择",
                                    },
                                    model: {
                                      value: _vm.detailForm.auditorGender,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.detailForm,
                                          "auditorGender",
                                          $$v
                                        )
                                      },
                                      expression: "detailForm.auditorGender",
                                    },
                                  },
                                  _vm._l(
                                    _vm.sexOptions,
                                    function (item, index) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: item.object,
                                          value: item.key,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "is-required",
                                attrs: {
                                  label: "学历",
                                  prop: "auditorEducation",
                                  rules: _vm.rules.auditorEducation,
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      clearable: "",
                                      disabled: _vm.isForbidden,
                                      placeholder: "请选择",
                                    },
                                    model: {
                                      value: _vm.detailForm.auditorEducation,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.detailForm,
                                          "auditorEducation",
                                          $$v
                                        )
                                      },
                                      expression: "detailForm.auditorEducation",
                                    },
                                  },
                                  _vm._l(
                                    _vm.educationOptions,
                                    function (item, index) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: item.object,
                                          value: item.key,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "is-required",
                                attrs: {
                                  label: "专业",
                                  prop: "auditorMajor",
                                  rules: _vm.rules.auditorMajor,
                                },
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    disabled: _vm.isForbidden,
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.detailForm.auditorMajor,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.detailForm,
                                        "auditorMajor",
                                        $$v
                                      )
                                    },
                                    expression: "detailForm.auditorMajor",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "is-required",
                                attrs: {
                                  label: "从业年限(农业相关)",
                                  prop: "workYear",
                                  rules: _vm.rules.workYear,
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    disabled: _vm.isForbidden,
                                    clearable: "",
                                    placeholder: "请输入内容",
                                  },
                                  model: {
                                    value: _vm.detailForm.workYear,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.detailForm, "workYear", $$v)
                                    },
                                    expression: "detailForm.workYear",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "is-required",
                                attrs: {
                                  label: "审核员类型",
                                  prop: "auditorType",
                                  rules: _vm.rules.auditorType,
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticClass: "multiple_sel",
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      clearable: "",
                                      multiple: "",
                                      disabled: _vm.isForbidden,
                                      placeholder: "请选择",
                                    },
                                    model: {
                                      value: _vm.detailForm.auditorType,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.detailForm,
                                          "auditorType",
                                          $$v
                                        )
                                      },
                                      expression: "detailForm.auditorType",
                                    },
                                  },
                                  _vm._l(
                                    _vm.auditorTypeOptions,
                                    function (item, index) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: item.object,
                                          value: item.key,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "is-required",
                                attrs: {
                                  label: "E-Learning",
                                  prop: "elearning",
                                  rules: _vm.rules.elearning,
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      clearable: "",
                                      disabled: _vm.isForbidden,
                                      placeholder: "请选择",
                                    },
                                    model: {
                                      value: _vm.detailForm.elearning,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.detailForm,
                                          "elearning",
                                          $$v
                                        )
                                      },
                                      expression: "detailForm.elearning",
                                    },
                                  },
                                  _vm._l(
                                    _vm.elearningOptions,
                                    function (item, index) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: item.object,
                                          value: item.key,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "is-required",
                                attrs: {
                                  label: "审核资质(多选)",
                                  prop: "auditorQualification",
                                  rules: _vm.rules.auditorQualification,
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticClass: "multiple_sel",
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      clearable: "",
                                      multiple: "",
                                      disabled: _vm.isForbidden,
                                      placeholder: "请选择",
                                    },
                                    on: {
                                      change: _vm.auditorQualificationChange,
                                    },
                                    model: {
                                      value:
                                        _vm.detailForm.auditorQualification,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.detailForm,
                                          "auditorQualification",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "detailForm.auditorQualification",
                                    },
                                  },
                                  _vm._l(
                                    _vm.auditorQualificationOptions,
                                    function (item, index) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: item.object,
                                          value: item.key,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "is-required",
                                attrs: {
                                  label: "MGG管理年限",
                                  prop: "mmgManagerYear",
                                  rules: _vm.rules.mmgManagerYear,
                                },
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    disabled: _vm.isForbidden || _vm.isInput,
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.detailForm.mmgManagerYear,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.detailForm,
                                        "mmgManagerYear",
                                        $$v
                                      )
                                    },
                                    expression: "detailForm.mmgManagerYear",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "审核员状态",
                                  prop: "auditorStatus",
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      disabled:
                                        _vm.isForbidden ||
                                        (_vm.detailForm.auditStatus !==
                                          "Approved" &&
                                          _vm.detailForm.auditStatus !==
                                            "Returned"),
                                      clearable: "",
                                      placeholder: "请选择",
                                    },
                                    model: {
                                      value: _vm.detailForm.auditorStatus,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.detailForm,
                                          "auditorStatus",
                                          $$v
                                        )
                                      },
                                      expression: "detailForm.auditorStatus",
                                    },
                                  },
                                  _vm._l(
                                    _vm.auditorStatusOptions,
                                    function (item, index) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: item.object,
                                          value: item.key,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "状态", prop: "auditStatus" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      disabled: "",
                                      clearable: "",
                                      placeholder: "请选择",
                                    },
                                    model: {
                                      value: _vm.detailForm.auditStatus,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.detailForm,
                                          "auditStatus",
                                          $$v
                                        )
                                      },
                                      expression: "detailForm.auditStatus",
                                    },
                                  },
                                  _vm._l(
                                    _vm.auditStatusOptions,
                                    function (item, index) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: item.object,
                                          value: item.key,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm.$route.query.from === "edit"
                      ? _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 24 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "上次修改原因",
                                      prop: "lastUpdateReason",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        disabled: "",
                                        type: "textarea",
                                        maxlength: "1000",
                                        "show-word-limit": "",
                                        autosize: { minRows: 4, maxRows: 6 },
                                        placeholder: "请输入内容",
                                      },
                                      model: {
                                        value: _vm.lastUpdateReason,
                                        callback: function ($$v) {
                                          _vm.lastUpdateReason = $$v
                                        },
                                        expression: "lastUpdateReason",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 24 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "is-required",
                                attrs: {
                                  label: "修改原因",
                                  prop: "updateReason",
                                  rules: _vm.rules.updateReason,
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    disabled: _vm.isForbidden,
                                    type: "textarea",
                                    maxlength: "1000",
                                    "show-word-limit": "",
                                    autosize: { minRows: 4, maxRows: 6 },
                                    clearable: "",
                                    placeholder: "请输入内容",
                                  },
                                  model: {
                                    value: _vm.detailForm.updateReason,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.detailForm,
                                        "updateReason",
                                        $$v
                                      )
                                    },
                                    expression: "detailForm.updateReason",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "fpa",
          attrs: {
            title: "退回意见",
            visible: _vm.dialogReturnVisible,
            width: "30%",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogReturnVisible = $event
            },
            close: _vm.onClose,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "returnForm",
              attrs: { model: _vm.returnForm, rules: _vm.returnFormRules },
            },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "returnedReason" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      maxlength: "1000",
                      "show-word-limit": "",
                      autosize: { minRows: 4, maxRows: 6 },
                      placeholder: "请输入内容",
                    },
                    model: {
                      value: _vm.returnForm.returnedReason,
                      callback: function ($$v) {
                        _vm.$set(_vm.returnForm, "returnedReason", $$v)
                      },
                      expression: "returnForm.returnedReason",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { type: "flex", justify: "center" } },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.onConfirm },
                },
                [_vm._v("确定")]
              ),
              _c(
                "el-button",
                { attrs: { size: "mini" }, on: { click: _vm.onClose } },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Sponsor主数据",
            visible: _vm.dialogVisible,
            width: "40%",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _vm.dialogVisible
            ? _c("facilityList", { on: { selectData: _vm.selectData } })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }